import Swiper from 'swiper/dist/js/swiper.js';
window.mainTeaserSwiper = false;

function init() {
  const smallScreen               = (window.innerWidth <= 767) ? true : false;
  const headerElement             = document.querySelector('.header');
  const mainteaserSwiper          = document.querySelector('.mainteaser__swiper');
  const mainteaserSwiperSelector  = '.swiper-container.mainteaser__swiper';
  const mainteaserItems           = document.querySelector('.mainteaser__items');
  const mainteaserItemsVideo      = Array.from(document.querySelectorAll('.mainteaser__video'));

  if (mainteaserSwiper) {
    if (!window.mainTeaserSwiper) {
      window.mainTeaserSwiper = new Swiper (mainteaserSwiperSelector, {
        direction: 'horizontal',
        speed: 1000,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.mainteaser__pagination',
          type: 'bullets',
          clickable: true
        },
        on: {
          // init: function () {
          //   animateLoadingBar(this);
          // },
          // slideChangeTransitionEnd: function () {
          //   animateLoadingBar(this);
          // },
        },
      });

      function animateLoadingBar(swiper) {
        const loaderSelector = '.mainteaser__itemnextloader';
        const loaderAnimationClassName = 'mainteaser__itemnextloader--animated';

        Array.from(swiper.slides).map((slide) => {
          let loader = slide.querySelector(loaderSelector);
          loader.classList.remove(loaderAnimationClassName);
        });
        swiper.slides[swiper.activeIndex].querySelector(loaderSelector).classList.add(loaderAnimationClassName);
      }
    }

    //we set the items (container) height to make the "next loader" appear on bottom of screen
    // if (smallScreen && headerElement && mainteaserItems) {
    //   let itemsHeight = document.documentElement.clientHeight - headerElement.offsetHeight + 'px';
    //   mainteaserItems.style.height = itemsHeight;
    // } else {
    //   mainteaserItems.style.height = '';
    // }

    if (mainteaserItemsVideo) {
      mainteaserItemsVideo.map((video) => {
        setTimeout(function() {
          video.play();
        }, 3000); // transition duration of items
      });
    }

  }

}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Mainteaser.js